import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { GuildService } from '../services/guild.service';
import { BotGuild } from '../models/bot/guild';

@Injectable({
  providedIn: 'root'
})
export class channelLimitsGuard {
  constructor(
    private guildService: GuildService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const guildId = route.parent?.paramMap.get('id') || route.paramMap.get('id');
    if (!guildId) {
      this.router.navigate(['/']);
      return false;
    }

    return this.guildService.getGuildData(guildId).pipe(
      map(guild => {
        const hasCapacity = this.checkLimits(guild);
        if (!hasCapacity) {
          this.toastr.error('You have reached the maximum number of event channels.');
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.router.navigate(['/error']);
        return of(false);
      })
    );
  }

  private checkLimits(guild: BotGuild): boolean {
    return guild.channels.length < guild.limits.max_event_channels || guild.has_premium;
  }
}
